import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PhCropperOutputFile } from '@shared/components/ph-cropper/ph-cropper-output-file.interface';
import Cropper from 'cropperjs';

@Component({
  selector: 'app-ph-cropper',
  templateUrl: './ph-cropper.component.html',
  styleUrls: ['./ph-cropper.component.scss'], // style from package -> in styles.scss
})
export class PhCropperComponent implements OnInit {
  displayCropperModal: boolean = false;
  @ViewChild('cropperImg', { static: true })
  public cropperImg: any;
  @ViewChild('cropper', { static: true })
  public cropper: any;
  @Input() configCropper: Cropper.Options = {
    autoCropArea: 0.8,
    viewMode: 1,
    zoomable: true,
    aspectRatio: 4 / 3,
    rotatable: true,
    scalable: true,
    dragMode: 'move',
    checkOrientation: true,
  };

  @Input() imageFormat: string = 'webp';
  cropperBox: any = null;
  @Output()
  phCropperChange: EventEmitter<PhCropperOutputFile> = new EventEmitter();
  currentNameCall: string = 'phCropperName';
  loading: boolean = true; // yea, default is 'true'
  fileOptions: { type: string; quality: number } = {
    type: `image/${this.imageFormat}`,
    quality: 0.7,
  };

  constructor() {}

  ngOnInit() {
    this.cropperBox = new Cropper(this.cropperImg.nativeElement, this.configCropper);
  }

  rotate() {
    this.cropperBox.rotate(90);
  }

  reset() {
    this.cropperBox.reset();
  }

  newImg(el) {
    this.cropperBox.replace(el.event);
    this.currentNameCall = el.name;
    this.openModal();
  }

  crop() {
    this.loading = true;

    // ('Turning speed of javascript code' > 'Turning speed of DOM manipulation')
    // so, setTimeout only for correctly show 'loading' status
    setTimeout(() => {
      const cropperCan = this.cropperBox.getCroppedCanvas();

      // '0.7' - downgrade img quality only for base64 (server get Blob. Base64 only for front)
      const base64 = cropperCan.toDataURL(this.fileOptions.type, this.fileOptions.quality);
      cropperCan.toBlob(
        (blob) => {
          // danger, ('Size of base64' > 'Size of blob')
          const pack: PhCropperOutputFile = {
            base64,
            blob,
            name: this.currentNameCall,
          };

          // danger, this emit send BIG size data. From 5 - 30 seconds or more
          this.phCropperChange.emit(pack);

          // hack for mobile (close modal after click on 'Crop' btn)
          this.cropper.nativeElement.click();
        },
        this.fileOptions.type,
        this.fileOptions.quality
      );
    }, 300);
  }

  cancel() {
    const pack: PhCropperOutputFile = {
      base64: null,
      blob: null,
      name: this.currentNameCall,
    };
    this.phCropperChange.emit(pack);
    this.closeModal();
  }

  openModal() {
    this.displayCropperModal = true;
  }

  closeModal() {
    this.displayCropperModal = false;
  }
}
